module.exports = __webpack_public_path__ + "img/scene_work.c919d6a4.webp";